
import {
  defineComponent,
  onMounted,
  ref,
  computed,
  reactive,
  watch,
} from "vue";
import { StepperComponent } from "@/assets/ts/components/_StepperComponent";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { useMutation, useLazyQuery, useQuery } from "@vue/apollo-composable";
import { getIllustrationsPath } from "@/core/helpers/assets";
import PenyediaanModal from "@/components/modals/forms/PenyediaanModal.vue";
import { ElementAnimateUtil } from "@/assets/ts/_utils";
import {
  setCurrentPageBreadcrumbs,
  setCurrentPageTitle,
} from "@/core/helpers/breadcrumb";
import moment from "moment";
import { useRoute, useRouter } from "vue-router";
import {
  naikPangkatBorangView,
  naikPangkatBorangCreate,
  naikPangkatBorangList,
  naikPangkatBorangCalon,
  naikPangkatBorangUpdate,
} from "@/apollo/perkhidmatan/naikpangkat";
import { Field, Form } from "vee-validate";
import * as Yup from "yup";
import { comboNegeri } from "@/apollo/pentadbiran/combo";
import Datepicker from "@vuepic/vue-datepicker";
import { listDaerah } from "@/apollo/pentadbiran/daerah";
import { SwalInfo } from "@/core/helpers/swal_helper";
import MyAxios from "@/core/helpers/axios_helper";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default defineComponent({
  name: "Borang4",
  components: {
    PenyediaanModal,
    Form,
    Datepicker,
    VueSelect,
  },
  data() {
    return {
      showModal: false,
      tarikh1: "",
      tarikh2: "",
      pickerOptions1: {
        disabledDate(date) {
          const pastDate = new Date();
          pastDate.setFullYear(pastDate.getFullYear());
          return date > pastDate;
        },
      },
      pickerOptions: {
        disabledDate(date) {
          return date < Date.now();
        },
      },
      hover: false,
      
      isSelectedNegeriDaerahFirstSync: true,
    };
  },

  watch:{
    lokasi(){
      console.log('lokasi penempatan khas changed', this.lokasi);
      if(this.lokasi == true) {
        if(this.isSelectedNegeriDaerahFirstSync == true){
          this.selectedNegeriDaerah = this.data.lokasi_penempatan_khas.map((item:any, index:number) => {
            return {
              negeri: item.negeri,
              daerah: this.filteredDaerah.find((itemDaerah:any) => item.poskod == itemDaerah?.kod_daerah),
              key: index+1,
            };
          });

          console.log('selected negeri daerah after sync', this.selectedNegeriDaerah);
        }
        this.isSelectedNegeriDaerahFirstSync = false;
      }
    },
  },

  mounted() {
    // Show the modal after the component is mounted
    // this.showModal = true;
    SwalInfo({
      title: "Kemaskini Iklan",
      msg: "Sila pastikan paparan iklan hanya akan dipaparkan mengikut tarikh permohonan tamat.",
    });

    (async () => {
      try {
        // Fetching PMK category
        let req = await MyAxios.get(
          "/api/perkhidmatan/penyediaan-calon/jenis-permohonan",
          {
            params: { kategori: "PMK" },
          }
        );
        this.opsiSkimPemangkuan = req.data
          .map((item: any) => ({
            ...item,
            value: item.kod,
          }))
          .sort((a: any, b: any) => a.label.localeCompare(b.label)); // Sort by 'label'
      } catch (ex) {
        console.log(
          "PenyediaanNew :: init opsiSkimPemangkuan :: exception",
          ex
        );
      }

      try {
        // Fetching KNP category
        let req = await MyAxios.get(
          "/api/perkhidmatan/penyediaan-calon/jenis-permohonan",
          {
            params: { kategori: "KNP" },
          }
        );
        this.opsiSkimKenaikanPangkat = req.data
          .map((item: any) => ({
            ...item,
            value: item.kod,
          }))
          .sort((a: any, b: any) => a.label.localeCompare(b.label)); // Sort by 'label'
      } catch (ex) {
        console.log(
          "PenyediaanNew :: init opsiSkimKenaikanPangkat :: exception",
          ex
        );
      }
    })();
  },

  methods: {
    changeStatus(status) {
      this.data.status = status;
      this.showModal = false;
    },

    findLabel(id, combo) {
      let label = "";
      if (combo != null) {
        combo.forEach((element) => {
          if (id == element.value) {
            label = element.label;
          }
        });
      }
      return label;
    },
    removeLokasiPenempatanField(item: any){
      this.selectedNegeriDaerah = this.selectedNegeriDaerah.filter((nd) => {
        if (nd.key == item.key) {
          return false;
        }
        return true;
      });
    },
    addLokasiPenempatanField() {
      this.selectedNegeriDaerah.push({
        negeri: "",
        daerah: { nama_daerah: "" },
        key: 1 + Math.max(...this.selectedNegeriDaerah.map((nd) => nd.key)),
      });
      console.log(
        "PenyediaanNew :: addLokasiPenempatanField ::",
        this.selectedNegeriDaerah
      );
    },
    optDaerahFilteredByNegeri(negeriId:any){
      const negeri = this.combo.negeri.find((item) => item.value == negeriId);
      if(negeri == null){
        return [];
      }

      console.log('optDaerahFilteredByNegeri', {negeri, optDaerah:this.optDaerah});
      const result = this.optDaerah.filter((item:any) => item.kod_daerah.substring(0,2) == negeri.kod);
      console.log('optDaerahFilteredByNegeri', {result});
      return result;
    },
  },
  setup() {
    const searchDaerah = ref("");
    const selectedDaerah = ref(null);
    const selectedNegeri = ref("");
    const selectedItem = ref(null);

    const optDaerah = ref([] as any[]);

    const searchDaerah2 = ref("");
    const selectedDaerah2 = ref(null);
    const selectedNegeri2 = ref("");

    const secondDropdownIsOpen = ref(false);

    const opsiSkimPemangkuan = ref([] as any[]);
    const opsiSkimKenaikanPangkat = ref([] as any[]);

    const selectedNegeriDaerah = ref([
        { negeri: "", daerah: "", key: 1 },
      ] as any[]);

    const displaySecondDropdown = () => {
      secondDropdownIsOpen.value = true; // Show second dropdown when Add Item button is clicked
    };

    const state = reactive({
      isOpen: false,
    });

    const state2 = reactive({
      isOpen: false,
    });

    const route = useRoute();
    const data = ref({} as any);
    const _stepperObj = ref<StepperComponent | null>(null);
    const penyediaanCalon = ref<HTMLElement | null>(null);
    const currentStepIndex = ref(0);
    const total = ref(1);
    const router = useRouter();
    const lokasi = ref(false);
    const dateDiff = ref("");
    const notifikasi = ref(false);
    const tetapan = ref(false);
    const akauntan = ref(false);
    const currLabel = ref("");
    const lokasiPenempatan = ref([] as any[]);
    const poskodPenempatan = ref([] as any[]);
    const negeriPenempatan = ref([] as any[]);
    const tarikhKriteria = reactive({
      mula: "",
      tamat: "",
    });
    const tarikhPermohonan = reactive({
      mula: "",
      tamat: "",
    });
    const markah_lnpt = reactive({
      mula: "",
      akhir: "",
    });
    const jenisDataPMK = ref([
      {
        value: "IKHTISAS",
        label: "Jawatan Akauntan Melalui Kelulusan Badan Ikhtisas",
        tajuk: "URUSAN PEMANGKUAN AKAUNTAN MELALUI KELULUSAN BADAN IKHTISAS",
      },
      {
        value: "W36_W40",
        label: "Penolong Akauntan W36 ke W40",
        tajuk:
          "URUSAN PERTIMBANGAN PEMANGKUAN JAWATAN PENOLONG AKAUNTAN GRED W36 KE W40",
      },
      {
        value: "W32_W36",
        label: "Penolong Akauntan W32 ke W36",
        tajuk: "URUSAN PEMANGKUAN JAWATAN PENOLONG AKAUNTAN GRED W32 KE W36",
      },
      {
        value: "W29_W32",
        label: "Penolong Akauntan W29 ke W32",
        tajuk: "URUSAN PEMANGKUAN JAWATAN PENOLONG AKAUNTAN GRED W29 KE W32",
      },
      {
        value: "W26_W28",
        label: "Pembantu Akauntan W26 ke W28",
        tajuk: "URUSAN PEMANGKUAN JAWATAN PEMBANTU AKAUNTAN GRED W26 KE W28",
      },
      {
        value: "W22_W26",
        label: "Pembantu Akauntan W22 ke W26",
        tajuk: "URUSAN PEMANGKUAN JAWATAN PEMBANTU AKAUNTAN GRED W22 KE W26",
      },
      {
        value: "W19_W22",
        label: "Pembantu Akauntan W19 ke W22",
        tajuk: "URUSAN PEMANGKUAN JAWATAN PEMBANTU AKAUNTAN GRED W19 KE W22",
      },
    ]);
    const jenisDataKNP = ref([
      {
        value: "PRO",
        label: "Akauntan",
        tajuk:
          "URUSAN KENAIKAN PANGKAT PEGAWAI AKAUNTAN PERKHIDMATAN PERAKAUNAN",
      },
      {
        value: "KNP_W19_W22",
        label: "Pembantu Akauntan W19 ke W22",
        tajuk: "URUSAN KENAIKAN PANGKAT PEMBANTU AKAUNTAN BAGI GRED W19 KE W22",
      },
      {
        value: "KNP_W22_W26",
        label: "Pembantu Akauntan W22 ke W26",
        tajuk: "URUSAN KENAIKAN PANGKAT PEMBANTU AKAUNTAN BAGI GRED W22 KE W26",
      },
      {
        value: "KNP_W26_W28",
        label: "Pembantu Akauntan W26 ke W28",
        tajuk: "URUSAN KENAIKAN PANGKAT PEMBANTU AKAUNTAN BAGI GRED W26 KE W28",
      },
      {
        value: "KNP_W29_W32",
        label: "Penolong Akauntan W29 ke W32",
        tajuk: "URUSAN KENAIKAN PANGKAT PENOLONG AKAUNTAN BAGI GRED W29 KE W32",
      },
      {
        value: "KNP_W32_W36",
        label: "Penolong Akauntan W32 ke W36",
        tajuk: "URUSAN KENAIKAN PANGKAT PENOLONG AKAUNTAN BAGI GRED W32 KE W36",
      },
      {
        value: "KNP_W36_W40",
        label: "Penolong Akauntan W36 ke W40",
        tajuk: "URUSAN KENAIKAN PANGKAT PENOLONG AKAUNTAN BAGI GRED W36 KE W40",
      },
      {
        value: "TBK1_W19_W22",
        label: "Time Based (TBK1) Bagi Gred W19 ke W22 Pembantu Akauntan",
        tajuk:
          "URUSAN KENAIKAN PANGKAT TIME BASED (TBK1) BAGI GRED W19 KE W22 PEMBANTU AKAUNTAN",
      },
      {
        value: "TBK2_W22_W26",
        label: "Time Based (TBK2) Bagi Gred W22 ke W26 Pembantu Akauntan",
        tajuk:
          "URUSAN KENAIKAN PANGKAT TIME BASED (TBK2) BAGI GRED W22 KE W26 PEMBANTU AKAUNTAN",
      },
      {
        value: "TBK1_W29_W32",
        label: "Time Based (TBK1) Bagi Gred W29 ke W32 Penolong Akauntan",
        tajuk:
          "URUSAN KENAIKAN PANGKAT TIME BASED (TBK1) BAGI GRED W29 KE W32 PENOLONG AKAUNTAN",
      },
      {
        value: "TBK2_W32_W36",
        label: "Time Based (TBK2) Bagi Gred W32 ke W36 Penolong Akauntan",
        tajuk:
          "URUSAN KENAIKAN PANGKAT TIME BASED (TBK2) BAGI GRED W32 KE W36 PENOLONG AKAUNTAN",
      },
      {
        value: "TBK1_H11_H14_PEMANDU",
        label: "Time Based (TBK1) Bagi Gred H11 Ke H14 (Pemandu Kenderaan)",
        tajuk:
          "URUSAN KENAIKAN PANGKAT TIME BASED (TBK1) BAGI GRED H11 KE H14 (PEMANDU KENDERAAN)",
      },
      {
        value: "TBK1_H11_H14_PA",
        label: "Time Based (TBK1) Bagi Gred H11 Ke H14 (Pembantu Awam)",
        tajuk:
          "URUSAN KENAIKAN PANGKAT TIME BASED (TBK1) BAGI GRED H11 KE H14 (PEMBANTU AWAM)",
      },
      {
        value: "TBK1_N11_N14",
        label: "Time Based (TBK1) Bagi Gred N11 Ke N14 (Pembantu Operasi)",
        tajuk:
          "URUSAN KENAIKAN PANGKAT TIME BASED (TBK1) BAGI GRED N11 KE N14 (PEMBANTU OPERASI)",
      },
      {
        value: "TBK1_N19_N22_PKP",
        label:
          "Time Based (TBK1) Bagi Gred N19 Ke N22 Pegawai Khidmat Pelanggan",
        tajuk:
          "URUSAN KENAIKAN PANGKAT TIME BASED (TBK1) BAGI GRED N19 KE N22 PEGAWAI KHIDMAT PELANGGAN",
      },
      {
        value: "TBK1_N19_N22_PA",
        label: "Time Based (TBK1) Bagi Gred N19 Ke N22 Penyelia Asrama",
        tajuk:
          "URUSAN KENAIKAN PANGKAT TIME BASED (TBK1) BAGI GRED N19 KE N22 PENYELIA ASRAMA",
      },
      {
        value: "TBK1_W19_W22_PTKW",
        label:
          "Time Based (TBK1) Bagi Gred W19 Ke W22 Pembantu Tadbir (Kewangan)",
        tajuk:
          "URUSAN KENAIKAN PANGKAT TIME BASED (TBK1) BAGI GRED W19 KE W22 PEMBANTU TADBIR (KEWANGAN)",
      },
      {
        value: "TBK1_N19_N22_PSP",
        label:
          "Time Based (TBK1) Bagi Gred N19 Ke N22 Pembantu / Setiausaha Pejabat",
        tajuk:
          "URUSAN KENAIKAN PANGKAT TIME BASED (TBK1) BAGI GRED N19 KE N22 PEMBANTU / SETIAUSAHA PEJABAT",
      },
      {
        value: "TBK1_N19_N22_PTPO",
        label:
          "Time Based (TBK1) Bagi Gred N19 Ke N22 Pembantu Tadbir (Perkeranian / Operasi)",
        tajuk:
          "URUSAN KENAIKAN PANGKAT TIME BASED (TBK1) BAGI GRED N19 KE N22 PEMBANTU TADBIR (PERKERANIAN / OPERASI)",
      },
      {
        value: "TBK1_N29_N32_PSP",
        label:
          "Time Based (TBK1) Bagi Gred N29 Ke N32 Pembantu / Setiausaha Pejabat",
        tajuk:
          "URUSAN KENAIKAN PANGKAT TIME BASED (TBK1) BAGI GRED N29 Ke N32 PEMBANTU / SETIAUSAHA PEJABAT",
      },
      {
        value: "TBK1_N29_N32_PPT",
        label: "Time Based (TBK1) Bagi Gred N29 Ke N32 Penolong Pegawai Tadbir",
        tajuk:
          "URUSAN KENAIKAN PANGKAT TIME BASED (TBK1) BAGI GRED N29 Ke N32 PENOLONG PEGAWAI TADBIR",
      },
      {
        value: "TBK2_H14_H16_PEMANDU",
        label: "Time Based (TBK2) Bagi Gred H14 Ke H16 (Pemandu Kenderaan)",
        tajuk:
          "URUSAN KENAIKAN PANGKAT TIME BASED (TBK2) BAGI GRED H14 KE H16 (PEMANDU KENDERAAN)",
      },
      {
        value: "TBK2_H14_H16_PA",
        label: "Time Based (TBK2) Bagi Gred H14 Ke H16 (Pembantu Awam)",
        tajuk:
          "URUSAN KENAIKAN PANGKAT TIME BASED (TBK2) BAGI GRED H14 KE H16 (PEMBANTU AWAM)",
      },
      {
        value: "TBK2_N14_N16",
        label: "Time Based (TBK2) Bagi Gred N14 Ke N16 (Pembantu Operasi)",
        tajuk:
          "URUSAN KENAIKAN PANGKAT TIME BASED (TBK2) BAGI GRED N14 Ke N16 (PEMBANTU OPERASI)",
      },
      {
        value: "TBK2_N22_N26_PTPO",
        label:
          "Time Based (TBK2) Bagi Gred N22 Ke N26 Pembantu Tadbir (Perkeranian / Operasi)",
        tajuk:
          "URUSAN KENAIKAN PANGKAT TIME BASED (TBK2) BAGI GRED N22 Ke N26 PEMBANTU TADBIR (PERKERANIAN /OPERASI)",
      },
      {
        value: "TBK2_N22_N26_PKP",
        label:
          "Time Based (TBK2) Bagi Gred N22 Ke N26 Pegawai Khidmat Pelanggan",
        tajuk:
          "URUSAN KENAIKAN PANGKAT TIME BASED (TBK2) BAGI GRED N22 Ke N26 PEGAWAI KHIDMAT PELANGGAN",
      },
      {
        value: "TBK2_N22_N26_PA",
        label: "Time Based (TBK2) Bagi Gred N22 Ke N26 Penyelia Asrama",
        tajuk:
          "URUSAN KENAIKAN PANGKAT TIME BASED (TBK2) BAGI GRED N22 Ke N26 PENYELIA ASRAMA",
      },
      {
        value: "TBK2_W22_W26_PTKW",
        label:
          "Time Based (TBK2) Bagi Gred W22 Ke W26 Pembantu Tadbir (Kewangan)",
        tajuk:
          "URUSAN KENAIKAN PANGKAT TIME BASED (TBK2) BAGI GRED W22 Ke W26 PEMBANTU TADBIR (KEWANGAN)",
      },
      {
        value: "TBK2_N22_N26_PSP",
        label:
          "Time Based (TBK2) Bagi Gred N22 Ke N26 Pembantu / Setiausaha Pejabat",
        tajuk:
          "URUSAN KENAIKAN PANGKAT TIME BASED (TBK2) BAGI GRED N22 Ke N26 PEMBANTU / SETIAUSAHA PEJABAT",
      },
      {
        value: "TBK2_N32_N36_PPT",
        label: "Time Based (TBK2) Bagi Gred N32 Ke N36 Penolong Pegawai Tadbir",
        tajuk:
          "URUSAN KENAIKAN PANGKAT TIME BASED (TBK2) BAGI GRED N32 Ke N36 PENOLONG PEGAWAI TADBIR",
      },
      {
        value: "TBK2_N32_N36_PSP",
        label:
          "Time Based (TBK2) Bagi Gred N32 Ke N36 Pembantu / Setiausaha Pejabat",
        tajuk:
          "URUSAN KENAIKAN PANGKAT TIME BASED (TBK2) BAGI GRED N32 Ke N36 PEMBANTU / SETIAUSAHA PEJABAT",
      },
    ]);
    const borangList = ref([] as any[]);
    const calonList = ref([]);
    const calonVars = ref({
      jenis_permohonan: "",
      tarikh_kriteria_mula: "",
      tarikh_kriteria_akhir: "",
    });
    const targetData = ref({
      kategori_permohonan: "KNP",
      jenis_permohonan: "",
      jenis_label: "",
      tahun: "",
      tajuk: "",
      bil_calon: 0,
      nota_tambahan: "",
      status: "",
      tarikh_kriteria_mula: "",
      tarikh_kriteria_akhir: "",
      tarikh_permohonan_mula: "",
      tarikh_permohonan_tamat: "",
      penempatan_khas: "",
      lokasi_penempatan_khas: [] as any[],
      hantar_notifikasi: "",
      markah_lnpt_tahun_mula: "",
      markah_lnpt_tahun_akhir: "",
    });

    const {
      result: daerahResult,
      loading: daerahLoading,
      load: executeDaerahQuery,
    } = useLazyQuery(listDaerah);

    watch(daerahResult, (newResult) => {
      console.log(daerahResult);
      if (newResult && newResult.data && newResult.data.daerahList) {
        console.log("Daerah Result:", newResult.data.daerahList);
      }
      optDaerah.value = daerahResult.value.daerahList;
    });

    const filteredDaerah = computed(() => {
      if (!daerahResult.value || !daerahResult.value.daerahList) return [];
      return daerahResult.value.daerahList.filter((daerah) =>
        daerah.nama_daerah
          .toLowerCase()
          .includes(searchDaerah.value.toLowerCase())
      );
    });

    const handleInput = () => {
      console.log("Current input: ", searchDaerah.value);
      executeDaerahQuery();
      state.isOpen = true;
    };

    const handleFocus = () => {
      state.isOpen = true;
    };

    const selectDaerah = (daerah) => {
      selectedDaerah.value = daerah;
      searchDaerah.value = daerah.nama_daerah;
      state.isOpen = false; // close the dropdown

      selectedItem.value = daerah;
    };

    const {
      result: daerahResult2,
      loading: daerahLoading2,
      load: executeDaerahQuery2,
    } = useLazyQuery(listDaerah);

    watch(daerahResult2, (newResult) => {
      if (newResult && newResult.data && newResult.data.daerahList) {
        console.log("Daerah Result 2:", newResult.data.daerahList);
      }
    });

    const filteredDaerah2 = computed(() => {
      if (!daerahResult2.value || !daerahResult2.value.daerahList) return [];
      return daerahResult2.value.daerahList.filter((daerah) =>
        daerah.nama_daerah
          .toLowerCase()
          .includes(searchDaerah2.value.toLowerCase())
      );
    });

    const handleInput2 = () => {
      executeDaerahQuery2();
      state2.isOpen = true;
    };

    const handleFocus2 = () => {
      state2.isOpen = true;
    };

    const handleTahunMulaChange = (newValue) => {
      if (newValue) {
        const endYear = newValue + 2;
        data.value.markah_lnpt_tahun_akhir = endYear;
      } else {
        // If start year is cleared, also clear end year
        data.value.markah_lnpt_tahun_akhir = null;
      }
    };

    const selectDaerah2 = (daerah) => {
      selectedDaerah2.value = daerah;
      searchDaerah2.value = daerah.nama_daerah;
      state2.isOpen = false;
    };

    const defaultStartDate = ref(new Date());
    defaultStartDate.value.setDate(defaultStartDate.value.getDate() + 1);
    const combo = reactive({
      negeri: [] as { value: string; label: string, kod: string }[],
    });

    const getIdFromParams = (param) => {
      if (Array.isArray(param)) {
        console.log("Received ID from params:", param[0]);
        return param[0];
      }
      console.log("Received ID from route params:", param);
      return param;
    };

    const rawId = getIdFromParams(route.params.id);
    const id = ref(rawId ? parseFloat(rawId) : null);
    console.log("Parsed ID for use:", id.value);

    const variables = { id: id.value };
    const {
      result,
      load: borangLoad,
      refetch: refetchBorang,
    } = useLazyQuery(naikPangkatBorangView, variables, {
      fetchPolicy: "no-cache",
    });

    watch(result, (value) => {
      console.log("edit naik pangkat :: Result", result.value);
      console.log("edit naik pangkat :: Result", value);
      // borangLoad();
      if (id.value !== 0 && value && value.naikPangkatBorangView) {
        const res = value.naikPangkatBorangView;
        data.value = {
          id: res.id,
          kategori_permohonan: res.kategori_permohonan,
          jenis_permohonan: res.jenis_permohonan,
          lokasi_penempatan_khas: res.lokasi_penempatan_khas,
          tarikh_kriteria_mula: res.tarikh_kriteria_mula,
          tarikh_kriteria_akhir: res.tarikh_kriteria_akhir,
          tarikh_permohonan_mula: res.tarikh_permohonan_mula,
          tarikh_permohonan_tamat: res.tarikh_permohonan_tamat,
          tahun: res.tahun,
          tajuk: res.tajuk,
          bil_calon: res.bil_calon,
          nota_tambahan: res.nota_tambahan,
          status: res.status,
          perakuan: res.perakuan,
          medan_tambahan: res.medan_tambahan,
          hantar_notifikasi: res.hantar_notifikasi,
          penempatan_khas: res.penempatan_khas,
          markah_lnpt_tahun_mula: res.markah_lnpt_tahun_mula,
          markah_lnpt_tahun_akhir: res.markah_lnpt_tahun_akhir,
        };

        tetapan.value = res.kategori_permohonan == "PMK";

        setTimeout(() => {
          lokasi.value = res.penempatan_khas == '1';
          
          console.log('penempatan khas?', lokasi.value);
          targetData.value.kategori_permohonan = res.kategori_permohonan;
          targetData.value.jenis_permohonan = res.jenis_permohonan;
          tarikhKriteria.mula = res.tarikh_kriteria_mula;
          tarikhKriteria.tamat = res.tarikh_kriteria_akhir;
          console.log("targetData:", targetData);
        }, 300);

        console.log("Data fetched:", data.value);
        console.log("ID results:", res.id);
      }
    });

    // Tajuk & label ikut skim yang baharu dipilih
    const onJenisPermohonanChange = () => {
      const jenisData = tetapan.value
        ? opsiSkimPemangkuan.value
        : opsiSkimKenaikanPangkat.value;
      const selectedJenis = jenisData.find(
        (x) => x.value == targetData.value.jenis_permohonan
      );
      if (selectedJenis == null) {
        return;
      }

      targetData.value.jenis_label = selectedJenis.label;
      targetData.value.tajuk = selectedJenis.tajuk;
      data.value.jenis_permohonan = selectedJenis.value;
      data.value.tajuk = selectedJenis.tajuk;
    };

    // Tahun dikira semula dari tempoh permohonan yang dikemaskini
    const kiraTahunIklan = () => {
      const rujukan =
        targetData.value.jenis_permohonan == "IKHTISAS"
          ? data.value?.tarikh_permohonan_mula
          : data.value?.tarikh_permohonan_tamat;
      const tahun = moment(rujukan ?? "");

      return tahun.isValid() ? tahun.year().toString() : data.value?.tahun;
    };

    const {
      mutate: NaikPangkatBorangCreate,
      onDone: naikPangkatBorangCreateDone,
      onError: naikPangkatBorangCreateError,
    } = useMutation(
      /*naikPangkatBorangCreate*/ naikPangkatBorangUpdate,
      () => ({
        variables: {
          id: id.value,
          kategori_permohonan: data.value?.kategori_permohonan,
          jenis_permohonan: targetData.value.jenis_permohonan,
          tarikh_kriteria_mula: moment(
            data.value?.tarikh_kriteria_mula ?? ""
          ).format("YYYY-MM-DD"),
          tarikh_kriteria_akhir: moment(
            data.value?.tarikh_kriteria_akhir ?? ""
          ).format("YYYY-MM-DD"),
          tarikh_permohonan_mula: moment(
            data.value?.tarikh_permohonan_mula ?? ""
          ).format("YYYY-MM-DD"),
          tarikh_permohonan_tamat: moment(
            data.value?.tarikh_permohonan_tamat ?? ""
          ).format("YYYY-MM-DD"),
          tahun: kiraTahunIklan(),
          tajuk: data.value?.tajuk,
          bil_calon: data.value?.bil_calon,
          nota_tambahan: data.value?.nota_tambahan,
          status: data.value?.status,
          penempatan_khas: data.value?.penempatan_khas,
          // lokasi_penempatan_khas: data.value?.lokasi_penempatan_khas,
          lokasi_penempatan_khas: selectedNegeriDaerah.value.map((nd) => ({
            lokasi: nd.daerah?.nama_daerah,
            poskod: nd.daerah?.kod_daerah,
            negeri: nd.negeri,
          })),
          hantar_notifikasi: data.value?.hantar_notifikasi,
          markah_lnpt_tahun_mula: String (data.value?.markah_lnpt_tahun_mula),
          markah_lnpt_tahun_akhir: String(data.value?.markah_lnpt_tahun_akhir),
        },
      })
    );

    // const triggerLoad = () => {
    //   if (id.value !== 0) {
    //     console.log('edit naik pangkat :: trigger load');
    //     borangLoad();
    //   }
    // };

    onMounted(() => {
      setCurrentPageBreadcrumbs("Jabatan", ["Borang"]),
        setCurrentPageTitle("Iklan Kenaikan Pangkat / Pemangkuan");
    });

    const {
      result: borangResult,
      refetch,
      load,
    } = useLazyQuery(naikPangkatBorangList, null, {
      fetchPolicy: "network-only",
    });
    watch(borangResult, (value) => {
      console.log("edit naik pangkat :: borang result", value);
      borangList.value = value.naikPangkatBorangList;
    });
    const { result: comboResult, load: comboLoad } = useLazyQuery(
      comboNegeri,
      null,
      {
        fetchPolicy: "no-cache",
      }
    );
    watch(comboResult, (value) => {
      combo.negeri = [];
      value.negeriList.forEach((k) => {
        combo.negeri.push({ value: k.id, label: k.nama_negeri, kod: k.kod_negeri });
      });
    });

    watch(tetapan, () => {
      lokasi.value = false;
      resetFields();
    });
    
    watch([akauntan, () => targetData.value.jenis_permohonan], ([newIsAkauntan, newJenisPermohonan]) => {
      const akauntanOptions = [
        'PRO',
        'PMK_WA41_WA44',
        'KNP_WA41_WA44',
        'PMK_WA44_WA48',
        'KNP_WA44_WA48',
        'PMK_WA48_WA52',
        'KNP_WA48_WA52',
        'PMK_WA52_WA54',
        'KNP_WA52_WA54',
        'IKHTISAS'
      ]
      akauntan.value = akauntanOptions.includes(newJenisPermohonan);

      // Kekalkan status tersimpan jika masih sah untuk jenis ini
      const statusSah = akauntan.value
        ? ['AKTIF', 'TIDAK AKTIF']
        : ['BUKA', 'BARU', 'SEMAKAN', 'SELESAI'];
      if (!statusSah.includes(data.value?.status)) {
        data.value.status = akauntan.value ? 'AKTIF' : 'BUKA';
      }
    });

    watch(
      () => targetData.value.jenis_permohonan,
      () => {
        if (targetData.value.jenis_permohonan) {
          if (targetData.value.jenis_permohonan == "IKHTISAS") {
            tarikhPermohonan.mula = moment().format("YYYY-MM-DD");
            tarikhPermohonan.tamat = moment()
              .add(20, "years")
              .format("YYYY-MM-DD");
          }
        }
      }
    );

    watch(
      () => markah_lnpt.mula,
      () => {
        if (markah_lnpt.mula && markah_lnpt.mula.toString().length == 4)
          markah_lnpt.akhir = (Number(markah_lnpt.mula) + 2).toString();
      }
    );

    watch(
      () => markah_lnpt.akhir,
      () => {
        if (markah_lnpt.akhir && markah_lnpt.akhir.toString().length == 4)
          markah_lnpt.mula = (Number(markah_lnpt.akhir) - 2).toString();
      }
    );

    onMounted(() => {
      console.log("edit naik pangkat :: on mounted");
      load();
      comboLoad();
      executeDaerahQuery();
      _stepperObj.value = StepperComponent.createInsance(
        penyediaanCalon.value as HTMLElement
      );
    });

    const maxDateForTahunMula = () => {
      const date = new Date();
      date.setFullYear(date.getFullYear() - 2);
      return date;
    };

    const formatDate = (date) => {
      return moment(date).format("DD MMM YYYY");
    };

    const totalSteps = computed(() => {
      if (!_stepperObj.value) {
        return;
      }

      return _stepperObj.value.totatStepsNumber;
    });

    const previousStep = () => {
      if (!_stepperObj.value) {
        return;
      }

      currentStepIndex.value--;

      _stepperObj.value.goPrev();
    };

    const handleStep = async (values: any) => {
      console.log("edit naik pangkat :: handlestep :: targetdata", {
        ...targetData,
      });
      ElementAnimateUtil.scrollTop(0, 600);
      targetData.value.tahun = new Date(tarikhPermohonan.tamat)
        .getFullYear()
        .toString();

      const jenis = tetapan.value ? "Pemangkuan" : "Kenaikan Pangkat";
      let jsonFlag = true;
      if (notifikasi.value) {
        targetData.value.hantar_notifikasi = "1";
      } else {
        targetData.value.hantar_notifikasi = "0";
      }

      targetData.value.status = "BARU";
      if (lokasi.value) {
        targetData.value.penempatan_khas = "1";
      } else {
        targetData.value.penempatan_khas = "0";
      }
      // const jenisData = tetapan.value ? jenisDataPMK.value : jenisDataKNP.value;
      const jenisData = tetapan.value
        ? opsiSkimPemangkuan.value
        : opsiSkimKenaikanPangkat.value;
      const selectedJenis = jenisData.find(
        (x) => x.value == targetData.value.jenis_permohonan
      );

      if (targetData.value.jenis_permohonan == "IKHTISAS") {
        targetData.value.tahun = new Date(tarikhPermohonan.mula)
          .getFullYear()
          .toString();
      }

      targetData.value.jenis_label = selectedJenis?.label ?? "Tiada Rekod";
      targetData.value.tajuk = selectedJenis?.tajuk ?? "Tiada Rekod";

      if (lokasi.value) {
        if (lokasiPenempatan.value.length > 0) {
          lokasiPenempatan.value.forEach((element) => {
            if (element == "") {
              jsonFlag = false;
            }
          });
        } else {
          jsonFlag = false;
        }

        if (poskodPenempatan.value.length > 0) {
          poskodPenempatan.value.forEach((element) => {
            if (element == "") {
              jsonFlag = false;
            }
          });
        } else {
          jsonFlag = false;
        }

        if (negeriPenempatan.value.length > 0) {
          negeriPenempatan.value.forEach((element) => {
            if (element == "") {
              jsonFlag = false;
            }
          });
        } else {
          jsonFlag = false;
        }

        for (var x = 0; x < lokasiPenempatan.value.length; x++) {
          targetData.value.lokasi_penempatan_khas[x] = {
            lokasi: lokasiPenempatan.value[x],
            poskod: poskodPenempatan.value[x],
            negeri: negeriPenempatan.value[x],
          };
          console.log(targetData.value.lokasi_penempatan_khas);
        }
      }

      if (
        tarikhKriteria.mula != null &&
        tarikhKriteria.mula != "" &&
        tarikhKriteria.tamat != null &&
        tarikhKriteria.tamat != ""
      ) {
        targetData.value.tarikh_kriteria_mula = moment(
          tarikhKriteria.mula
        ).format("YYYY-MM-DD");
        targetData.value.tarikh_kriteria_akhir = moment(
          tarikhKriteria.tamat
        ).format("YYYY-MM-DD");
      } else {
        targetData.value.tarikh_kriteria_mula = "";
        targetData.value.tarikh_kriteria_akhir = "";
      }

      if (
        tarikhPermohonan.mula != null &&
        tarikhPermohonan.mula != "" &&
        tarikhPermohonan.tamat != null &&
        tarikhPermohonan.tamat != ""
      ) {
        targetData.value.tarikh_permohonan_mula = moment(
          tarikhPermohonan.mula
        ).format("YYYY-MM-DD");
        targetData.value.tarikh_permohonan_tamat = moment(
          tarikhPermohonan.tamat
        ).format("YYYY-MM-DD");
      } else {
        targetData.value.tarikh_permohonan_mula = "";
        targetData.value.tarikh_permohonan_tamat = "";
      }

      targetData.value.markah_lnpt_tahun_mula = markah_lnpt.mula;
      targetData.value.markah_lnpt_tahun_akhir = markah_lnpt.akhir;

      var start = moment(tarikhPermohonan.mula).locale("ms-my");
      var end = moment(tarikhPermohonan.tamat).locale("ms-my");
      dateDiff.value = end.from(start, true);

      const kenaikanPangkatSchema = Yup.object({
        kategori_permohonan: Yup.string().required().label("Kategori Permohon"),
        jenis_permohonan: Yup.string().required().label("Jenis Permohonan"),
      });

      const jenisKenaikanPangkatValidation =
        await kenaikanPangkatSchema.isValid({
          kategori_permohonan: targetData.value.kategori_permohonan,
          jenis_permohonan: targetData.value.jenis_permohonan,
        });

      const tarikhKriteriaSchema = Yup.object({
        tarikh_kriteria_mula: Yup.string()
          .required()
          .label("Tarikh Kriteria Mula"),
        tarikh_kriteria_akhir: Yup.string()
          .required()
          .label("Tarikh Kriteria Akhir"),
      });

      const tarikhKriteriaValidation = await tarikhKriteriaSchema.isValid({
        tarikh_kriteria_mula: targetData.value.tarikh_kriteria_mula,
        tarikh_kriteria_akhir: targetData.value.tarikh_kriteria_akhir,
      });

      const tarikhPermohonanSchema = Yup.object({
        tarikh_permohonan_mula: Yup.string()
          .required()
          .label("Tarikh Permohonan Mula"),
        tarikh_permohonan_tamat: Yup.string()
          .required()
          .label("Tarikh Permohonan Tamat"),
      });

      const tarikhPermohonanValidation = await tarikhPermohonanSchema.isValid({
        tarikh_permohonan_mula: targetData.value.tarikh_permohonan_mula,
        tarikh_permohonan_tamat: targetData.value.tarikh_permohonan_tamat,
      });

      const markah_lnptSchema = Yup.object({
        markah_lnpt_tahun_mula: Yup.string().required().label("Tahun Mula"),
        markah_lnpt_tahun_akhir: Yup.string().required().label("Tahun Akhir"),
      });

      const tahunValidation = await markah_lnptSchema.isValid({
        markah_lnpt_tahun_mula: targetData.value.markah_lnpt_tahun_mula,
        markah_lnpt_tahun_akhir: targetData.value.markah_lnpt_tahun_akhir,
      });

      let existFlag = false;

      borangList.value.forEach((element) => {
        if (
          targetData.value.tarikh_permohonan_mula ==
            element.tarikh_permohonan_mula &&
          targetData.value.tarikh_permohonan_tamat ==
            element.tarikh_permohonan_tamat
        ) {
          if (
            targetData.value.kategori_permohonan == element.kategori_permohonan
          ) {
            if (targetData.value.jenis_permohonan == element.jenis_permohonan) {
              existFlag = true;
            }
          }
        }
      });

      if (existFlag) {
        Swal.fire({
          text:
            "Borang " +
            targetData.value.jenis_label +
            " sudah wujud bagi tarikh permohonan " +
            targetData.value.tarikh_permohonan_mula +
            " " +
            "hingga" +
            " " +
            targetData.value.tarikh_permohonan_tamat +
            "!",
          icon: "warning",
          buttonsStyling: false,
          confirmButtonText: "Ok",
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
        return;
      }

      currentStepIndex.value++;
      if (!_stepperObj.value) {
        console.log(
          "edit naik pangkat :: handle step :: stepper obj is invalid :: return"
        );
        return;
      }

      console.log("edit naik pangkat :: handle step :: re-init calonvars");
      calonVars.value = {
        jenis_permohonan: targetData.value.jenis_permohonan,
        tarikh_kriteria_mula: moment(tarikhKriteria.mula).format("YYYY-MM-DD"),
        tarikh_kriteria_akhir: moment(tarikhKriteria.tamat).format(
          "YYYY-MM-DD"
        ),
      };
      console.log(
        "edit naik pangkat :: handle step :: re-init calonvars :: res",
        calonVars.value
      );

      if (currentStepIndex.value == 1) {
        console.log(
          "edit naik pangkat :: handle step :: call function calonLoad"
        );
        calonLoad();
      }
      _stepperObj.value.goNext();
      console.log("edit naik pangkat :: handlestep :: targetdata", {
        ...targetData,
      });
    };

    naikPangkatBorangCreateError((err) => {
      Swal.fire({
        text: err.message,
        icon: "error",
        buttonsStyling: false,
        confirmButtonText: "Ok",
        customClass: {
          confirmButton: "btn btn-primary",
        },
      });
    });
    naikPangkatBorangCreateDone(() => {
      Swal.fire({
        text: "Borang berjaya dikemaskini!",
        icon: "success",
        buttonsStyling: false,
        confirmButtonText: "Ok",
        customClass: {
          confirmButton: "btn btn-primary",
        },
      }).then(() => {
        router.push({ name: "naikpangkatlist3" });
      });
    });

    const formSubmit = async () => {
      console.log("TargetData", targetData);

      NaikPangkatBorangCreate();
    };
    const clearArray = () => {
      lokasiPenempatan.value = [];
      negeriPenempatan.value = [];
      poskodPenempatan.value = [];
    };

    const {
      result: calonResult,
      load: calonLoad,
      onError: onGetBorangCalonError,
    } = useLazyQuery(naikPangkatBorangCalon, calonVars, {
      fetchPolicy: "no-cache",
    });

    watch(calonResult, (value) => {
      console.log(
        "edit naik pangkat :: calonResult :: naikpangkatborangcalon",
        value
      );
      calonList.value = value.naikPangkatBorangCalon;
    });
    onGetBorangCalonError((err) => {
      console.log("edit naik pangkat :: get borang calon error ::", err);
    });

    onMounted(() => {
      console.log("edit naik pangkat :: on mounted ::: borangload");
      borangLoad();
    });

    return {
      optDaerah,
      opsiSkimPemangkuan,
      opsiSkimKenaikanPangkat,
      defaultStartDate,
      maxDateForTahunMula,
      total,
      handleStep,
      formSubmit,
      previousStep,
      penyediaanCalon,
      currentStepIndex,
      totalSteps,
      getIllustrationsPath,
      targetData,
      formatDate,
      lokasi,
      notifikasi,
      tetapan,
      akauntan,
      lokasiPenempatan,
      poskodPenempatan,
      negeriPenempatan,
      tarikhKriteria,
      tarikhPermohonan,
      jenisDataPMK,
      jenisDataKNP,
      currLabel,
      dateDiff,
      combo,
      clearArray,
      calonList,
      markah_lnpt,
      data,
      // triggerLoad,
      refetchBorang,
      daerahLoading,
      searchDaerah,
      searchDaerah2,
      selectedDaerah,
      filteredDaerah,
      selectDaerah,
      handleInput,
      handleInput2,
      handleFocus,
      handleFocus2,
      state,
      state2,
      selectedNegeri,
      selectedItem,
      displaySecondDropdown,
      secondDropdownIsOpen,
      selectedNegeri2,
      filteredDaerah2,
      selectedNegeriDaerah,
      selectedDaerah2,
      selectDaerah2,
      handleTahunMulaChange,
      onJenisPermohonanChange,
    };

    function resetFields() {
      targetData.value.kategori_permohonan = tetapan.value ? "PMK" : "KNP";
      targetData.value.jenis_permohonan = "";
      targetData.value.jenis_label = "";
      targetData.value.tahun = "";
      targetData.value.tajuk = "";
      targetData.value.bil_calon = 0;
      targetData.value.nota_tambahan = "";
      targetData.value.status = "";
      targetData.value.tarikh_kriteria_mula = "";
      tarikhKriteria.mula = "";
      targetData.value.tarikh_kriteria_akhir = "";
      tarikhKriteria.tamat = "";
      targetData.value.tarikh_permohonan_mula = "";
      tarikhPermohonan.mula = "";
      targetData.value.tarikh_permohonan_tamat = "";
      tarikhPermohonan.tamat = "";
      markah_lnpt.mula = "";
      markah_lnpt.akhir = "";
      targetData.value.markah_lnpt_tahun_mula = "";
      targetData.value.markah_lnpt_tahun_akhir = "";
      targetData.value.penempatan_khas = "";
      targetData.value.lokasi_penempatan_khas = [] as any[];
      targetData.value.hantar_notifikasi = "";
    }
  },
});
